<template functional>
  <div style="align-content: center">
    <div
      v-if="
        props.row.approval_range_details &&
        props.row.approval_range_details.length
      "
    >
      <div
        v-for="(detail, index) in props.row.approval_range_details"
        :key="index"
      >
        <strong
          ><translate-text keyTranslate="shopping.range" /> {{ index + 1 }}:
        </strong>
        <div v-if="detail.deleted_at">
          <translate-text keyTranslate="common_words.disable" />
        </div>
        <div v-else>
          <translate-text keyTranslate="common_words.enable" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'RangeStatuses',
};
</script>
